import React from 'react'
// components
import { Link } from 'components/UI'
// context
import { RiskViewContext } from 'containers/Risks/RiskView/Risk/layers'
// views
import { LinksWrapper, Parent } from './views'
// icons
import ArrowRightIcon from '@mui/icons-material/SyncAlt'

interface LinkConfig {
  pathname: string
  label: string
}

const RiskParent: React.FC = () => {
  const { risk } = React.useContext(RiskViewContext)

  const isLinkedRisk = !!risk.mainRisk
  const isImportedRisk = !!risk.realRiskId
  const hasParent = !!risk.parentRiskId
  const hasSubParent = hasParent && (isImportedRisk || isLinkedRisk)

  const buildMainParentLink = (): LinkConfig | null => {
    if (!isLinkedRisk && !hasParent) {
      return null
    }

    const parentRisk = isLinkedRisk ? risk.mainRisk : risk.parentRisk

    return {
      pathname: `/forms/edit/${parentRisk.id}/template/${parentRisk.riskTemplate.id}`,
      label: parentRisk.riskTemplate.name
    }
  }

  const buildSubParentLink = (): LinkConfig | null => {
    if (!isImportedRisk && !isLinkedRisk) {
      return null
    }

    const riskId = isLinkedRisk ? risk.parentRiskId : risk.realRiskId
    const template = isLinkedRisk ? risk.parentRisk.riskTemplate : risk.riskTemplate

    return {
      pathname: `/forms/edit/${riskId}/template/${template.id}`,
      label: template.name
    }
  }

  const mainParentLink = buildMainParentLink()
  const subParentLink = buildSubParentLink()

  return (
    <Parent>
      <LinksWrapper hasSubParent={hasSubParent}>
        {mainParentLink && (
          <Link target='_blank' href={mainParentLink}>
            {mainParentLink.label}
          </Link>
        )}
        {subParentLink && (
          <Link target='_blank' href={subParentLink}>
            {subParentLink.label}
          </Link>
        )}
      </LinksWrapper>
      {hasSubParent && <ArrowRightIcon />}
    </Parent>
  )
}

export default RiskParent
